<div id="layout-wrapper" (window:resize)="onResize($event)">
    <!-- Top Bar -->
    <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
    <!-- Side Bar -->
    <app-sidebar></app-sidebar>
    <div class="main-content">
        <div class="page-content">
            <div class="container-fluid">
                <!-- Main Content -->
                <div>
                    <div class="progress animated-progress"
                        *ngIf="progressBarService.progress > 0
                            && progressBarService.progress <= 100"
                        >
                        <div class="progress-bar"
                        role="progressbar"
                        [style.width.%]="progressBarService.progress"
                        aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <!-- Footer -->
        <app-footer></app-footer>
    </div>
</div>
<!-- Right Side Bar -->
<app-rightsidebar (settingsButtonClicked)="onSettingsButtonClicked()"></app-rightsidebar>